import React, { createContext, useContext, useState, useEffect } from 'react';
import { getLanguage, setLanguage as persistLanguage } from '../utils/languageStorage';

// 1. Create a Context
const LanguageContext = createContext();

// 2. Create a Provider Component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => getLanguage());

  // 언어 상태가 변경될 때 쿠키/localStorage에 저장
  useEffect(() => {
    persistLanguage(language);
  }, [language]);

  // 다른 탭/도메인에서 언어 변경 시 탭 전환하면 쿠키 재확인
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const newLang = getLanguage();
        setLanguage(prev => (prev !== newLang ? newLang : prev));
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  const toggleLanguage = () => {
    setLanguage(prevLanguage => (prevLanguage === 'ko' ? 'en' : 'ko'));
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// 3. Create a custom hook to use the LanguageContext
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
